<template>
  <footer class="main-footer">
      <div class="container d-flex flex-column justify-content-center">
        <div class="d-flex justify-content-center">
          <ul class="d-flex flex-wrap mb-lg-2 mb-0 justify-content-center">
            <li class="mr-3 mb-3 mb-md-0">
              <a href="https://www.instagram.com/scrivapp/" class="rounded-xl bordered-1 border-white link-color1 social-icon" target="_blank"><i class="fa fa-instagram"></i></a>
            </li>
            <li class="mr-3 mb-3 mb-md-0">
              <a href="https://twitter.com/scrivapp" class="rounded-xl bordered-1 border-white link-color1 social-icon" target="_blank"><i class="fa fa-twitter"></i></a>
            </li>
            <li class="mr-3 mb-3 mb-md-0">
              <a href="https://www.linkedin.com/company/75733871" class="rounded-xl bordered-1 border-white link-color1 social-icon" target="_blank"><i class="fa fa-linkedin"></i></a>
            </li>
            <li class="mr-3 mb-3 mb-md-0">
              <a href="https://www.facebook.com/scrivapp" class="rounded-xl bordered-1 border-white link-color1 social-icon" target="_blank"><i class="fa fa-facebook"></i></a>
            </li>
            <li class="mr-3 mb-3 mb-md-0">
              <a href="https://open.spotify.com/show/77kkJ5WrnvC83L74mSSea7" class="rounded-xl bordered-1 border-white link-color1 social-icon" target="_blank"><i class="fa fa-spotify"></i></a>
            </li>
          </ul>
        </div>
        <div class="mt-3 justify-content-lg-center d-lg-flex">
          <ul class="d-lg-flex align-items-lg-center font-size-lg-small mb-lg-0">
              <li class="mr-lg-4 mb-2 mb-lg-0">
                <router-link
                  :to="{ name: 'statics.about' }"
                >
                  Sobre Nós
                </router-link>
              </li>
              <li class="mr-lg-4 mb-2 mb-lg-0">
                <router-link
                  :to="{ name: 'statics.wallet' }"
                >
                  Scriv Wallet
                </router-link>
              </li>
              <li class="mr-lg-4 mb-2 mb-lg-0">
                <router-link
                  :to="{ name: 'statics.contact' }"
                >
                  Contato
                </router-link>
              </li>
              <li class="mr-lg-4 mb-2 mb-lg-0">
                <router-link
                  :to="{ name: 'statics.faq' }"
                >
                  Perguntas Frequentes
                </router-link>
              </li>
              <li class="mr-lg-4 mb-2 mb-lg-0">
                <router-link
                  :to="{ name: 'statics.privacy' }"
                >
                  Política de Privacidade
                </router-link>
              </li>
              <li class="mr-lg-4 mb-2 mb-lg-0">
                <router-link
                  :to="{ name: 'statics.moderation' }"
                >
                  Regras de Moderação
                </router-link>
              </li>
              <li class="mb-2 mb-lg-0">
                <router-link
                  :to="{ name: 'statics.terms' }"
                >
                  Termos e Condições
                </router-link>
              </li>
            </ul>
        </div>
        <div>
          <p class="text-center font-size-xSmall mt-3">@2022 - Todos os direitos reservados</p>
        </div>
        <hr class="h-1 w-75 separator" />
        <div class="logo-kingly text-center">
            <span class="d-block mb-2">powered by</span>
            <a href="http://kinglystudio.com.br" target="_blank"><img src="/images/layout/logo-kingly.png" alt=""></a>
        </div>
        <button type="button" class="back-top" @click="backToTop()">
          <i class="fa fa-angle-up"></i>
        </button>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  data () {
    return {
      animationId: null
    }
  },
  methods: {
    backToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  text-align: center;
  background: $color1;
  color: #fff;
  position: relative;

  .container {
    padding: 40px 0;
    position: relative;
  }

  a {
    color: #fff;

    &:hover {
      color: $color2;
    }
  }

  a.border-white {
    &:hover {
      border-color: $color2 !important;
    }
  }

  .social {
    .social-icon {
      font-size: 16px;
      width: 35px;
      height: 35px;
      line-height: 32px;
    }
  }

  .logo {
    img {
      width: 100px;
    }
  }

  .logo-kingly {
    font-size: $font_size_small;

    img {
      width: 100px;
    }
  }

  .separator {
    background: rgba(255,255,255,0.2);
  }

  .back-top {
    background: transparent;
    border: 1px solid #fff;
    position: absolute;
    opacity: 0.6;
    border-radius: 30px;
    top: 20px;
    right: 20px;
    line-height: 1;
    width: 30px;
    height: 30px;
    transition: all 0.2s ease-out;

    &:hover {
      border-color: $color2;
      background: $color2;
      opacity: 1;

      i {
        color: #fff;
      }
    }

    @include tablet {
      border-color: $color1;
      top: -50px;
      right: -22px;
    }

    @include desktop {
      right: 0;
    }

    @include desktop-lg {
      padding: 0;
    }

    i {
      color: #fff;
      transition: all 0.2s ease-out;

      @include tablet {
        color: $color1;
        margin-top: -2px;
        display: inline-block;
        vertical-align: top;
      }

      @include desktop-lg {
        margin-top: -1px;
      }
    }
  }
}
</style>
